import context from '@/context'
import { addAnswerToComment } from './utils/commentsUtils'
import commonErrorHandler from '@/utils/errors'

export const initialState = {

  ticketComments: [],
  fetching: false,
  adding: false
}

export const actionTypes = {

  Fetching: 'ticketComments/fetching',
  Fetched: 'ticketComments/fetched',
  Error: 'ticketComments/error',

  Adding: 'ticketComments/adding',
  Added: 'ticketComments/added'
}

const handleError = (details) => commonErrorHandler(actionTypes.Error, details)

export const actionCreators = {

  getComments: (ticketId, includeRelatedTickets) => (dispatch) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.ticketCommentsService.getComments(ticketId, includeRelatedTickets)
      .then(response => {
        dispatch({ type: actionTypes.Fetched, data: response })
      })
      .catch(error => handleError({ dispatch, error, update: { fetching: false } }))
  },
  addComment: (newComment) => (dispatch) => {
    dispatch({ type: actionTypes.Adding })
    context.api.ticketCommentsService.addComment(newComment)
      .then(response => {
        dispatch({ type: actionTypes.Added, data: newComment })
      })
      .catch(error => handleError({ dispatch, error, update: { adding: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, ticketComments: action.data }
    case actionTypes.Error: return { ...state, ...action.data }
    case actionTypes.Adding: return { ...state, adding: true }
    case actionTypes.Added:
    {
      const ticketComments = state.ticketComments.map(x => {
        if (x.id === action.data.entityId) {
          return { ...x, comments: addAnswerToComment(action.data, x.comments).comments }
        } else {
          return x
        }
      })
      return { ...state, adding: false, ticketComments }
    }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/TicketComments.js